import type { AxiosResponse } from 'axios';
import type { AssetResponse } from './types';

export function mapAssetResponse({ data }: AxiosResponse): AssetResponse {
  return { url: data.url, error: data.error };
}
